export function getPrices() {
	return {
		'early': {
			'standard': ['69.00', '139.00', '199.00', '279.00', '359.00']
		},
		'children': {
			'standard': ['199.00', '319.00', '449.00', '599.00', '749.00'],
			'deluxe': ['399.00', '699.00', '999.00', '1,349.00', '1,749.00']
		},
		'youth': {
			'standard': ['140.00', '220.00', '330.00', '440.00', '600.00']
		}
	};
}

export function updatePricing(ageLevel, optionIndex, priceElement, subLevel) {
	let prices = getPrices(),
		newPrice = prices[ageLevel][subLevel][optionIndex];
	
	priceElement.innerText = newPrice;
}

export function dropdown(event) {
	let content = event.target.closest('.content');
	content.classList.toggle('active');
}